import { render, staticRenderFns } from "./indiSplash.vue?vue&type=template&id=4b991094&scoped=true"
import script from "./indiSplash.vue?vue&type=script&lang=js"
export * from "./indiSplash.vue?vue&type=script&lang=js"
import style0 from "./indiSplash.vue?vue&type=style&index=0&id=4b991094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b991094",
  null
  
)

export default component.exports